import React, { useEffect, useState, } from 'react';
import { StyleSheet, css } from 'aphrodite';
import List from '@material-ui/core/List';
import { Button, CircularProgress } from '@material-ui/core';
import { Helper } from '../common/helpers/Helper';
import { AppTheme } from '../styles/AppTheme';
import { CommonStyles, CommonTheme } from '../styles/Styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import { SelectBox } from './SelectBox';

export function FilterDrawer(props) {
  const Styles = CreateStyleSheet()
  const fieldOrderByKey = {
    openoohcategory: {
      order: '001'
    },
    city: {
      order: '002'
    },
    countrycode: {
      order: '003'
    },
    zip: {
      order: '004'
    },
    dmacode: {
      order: '005'
    },
    height: {
      order: '006'
    },
    width: {
      order: '007'
    },
    azother: {
      order: '008'
    }
  }
  useEffect(() => {
    setFilterItems(props.item)
  }, [props.item])

  const sortFacets = () => {
    for (const i of props.item) {
      if (fieldOrderByKey[i.key]) {
        i.order = fieldOrderByKey[i.key].order
      } else {
        i.order = fieldOrderByKey.azother.order
      }
    }
    return Helper.sortDictArray(props.item)
  }
  const [filterItems, setFilterItems] = useState(sortFacets(props.item))
  const getTitleContainer = () => {
    return (
      <div className={css(Styles.drawerTitleContainer)}>
        <div className={css(Styles.titleContainer)}>
          <div className={css(Styles.titleSubContainer)}>
            <p className={css(Styles.title)}>{Helper.getString('filters')}</p>
            {props.inProcess &&
              <div className={css(Styles.loadingView)}>
                <CircularProgress size={24} />
              </div>
            }
          </div>
        </div>
        <div className={css(CommonStyles.closeIconContainer)} onClick={props.onClose}>
          <img
            src={require('../assets/images/close.svg')}
            alt={Helper.getString('dialogCloseAlt')}
            height='24' width='24'
            className={css(Styles.closeIcon)} />
        </div>
      </div>
    )
  }

  const getButtonContainer = () => {
    return (
      <div className={css(Styles.buttonsContainer)}>
        <Button
          disableRipple={true}
          onClick={() => props.onClear()}
          className={css(Styles.button)}>
          <p className={css(Styles.buttonText)}>{Helper.getString('resetAll')}</p>
        </Button>
      </div>
    )
  }

  const handleSelectBox = (item, key) => {
    const fParams = { ...props.selectedFilters }
    let incomingItem = item
    if (incomingItem && incomingItem.length > 1) {
      incomingItem = incomingItem.filter((v, i, a) => a.findIndex(v2 => (v2.key === v.key)) === i)
    }
    fParams[key] = incomingItem
    props.handleSelection(incomingItem, key)
  }

  const getItems = () => {
    const items = filterItems || []
    return (
      <div className={css(Styles.itemsContainer)}>
        {props.errMsg &&
          <p className={css(Styles.title, Styles.errMsg)}>{props.errMsg}</p>
        }
        <List className={css(Styles.listSubContainer)}>
          {(items && items.length > 0) ?
            items.map(item => {
              for (const f of item.values) {
                if (!f.key) {
                  f.key = f.value
                }
              }
              return (
                <SelectBox key={item.key}
                  item={item}
                  value={props.selectedFilters && props.selectedFilters[item.key] || []}
                  handleSelectBox={handleSelectBox} />
              )
            })
            :
            <span className={css(Styles.emptyFacets)}>{Helper.getString('noResults')}</span>
          }
        </List>
      </div>
    )
  }

  const renderList = () => {
    return (
      <div className={css(Styles.listContainer)} >
        {getTitleContainer()}
        {getItems()}
        {getButtonContainer()}
      </div>
    )
  }

  return (
    <SwipeableDrawer
      anchor='right'
      open={props.open || false}
      onClose={props.onClose}
      onOpen={props.onOpen}
      classes={{
        paper: css(Styles.drawerPaper),
        root: css(Styles.drawerRoot)
      }}
    >
      {renderList()}
    </SwipeableDrawer>
  );
}


const buttonBottomValueMobile = 58
const buttonBottomValue = 64
function CreateStyleSheet() {
  return StyleSheet.create({
    drawerPaper: {
      width: '100%',
      minHeight: '100vh',
      backgroundColor: '#FFFFFF',
      maxWidth: '30%',
      visibility: 'visible',
      display: 'flex',
      '@media(max-width: 767px)': {
        maxWidth: 'unset',
      },
    },
    listContainer: {
      padding: '0px 40px',
      paddingBottom: buttonBottomValue,
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      // position: 'relative',
      '@media(max-width: 767px)': {
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: buttonBottomValueMobile + buttonBottomValue,
      },
    },
    drawerRoot: {
      // zIndex: 100
    },
    title: {
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '21px',
      // textTransform: 'uppercase',
      margin: 0
    },
    errMsg: {
      color: '#fc4242',
      textTransform: 'capitalize',
      fontSize: 14,
      paddingBottom: 10
    },
    buttonStyle: {
      minHeight: 'unset',
      height: 38,
      minWidth: 100,
      margin: '0px 20px',
      marginBottom: 20,
      background: 'linear-gradient(87.69deg, #F3819A -0.9%, #FBBD96 100%)'
    },
    drawerTitleContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 20,
      position: 'fixed',
      paddingTop: AppTheme.toolbarHeight - 100,
      backgroundColor: '#FFFFFF',
      zIndex: 20,
      paddingRight: 50,
      gap: 20,
      paddingBottom: 15,
      width: '-webkit-fill-available',
    },
    buttonText: {
      margin: 0,
      fontSize: 16,
      fontWeight: 400,
      lineHeight: '19px',
      color: AppTheme.textColour,
      wordBreak: 'break-word',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      flex: 1,
      textTransform: 'capitalize',
      '@media (max-width: 767px)': {
        fontSize: 14,
        lineHeight: '17px',
      },
    },
    buttonsContainer: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#FFFFFF',
      '@media (max-width: 767px)': {
        bottom: buttonBottomValueMobile,
        padding: '10px 20px',
        // position: 'fixed',
        left: 0,
        right: 0
      },
    },
    button: {
      minHeight: 'unset',
      borderRadius: 0,
      //padding: '0px 10px',
      height: 44,
      flex: 1,
      backgroundColor: '#FFFFFF',
      border: '1px solid #A0A0A0',
      display: 'flex',
      alignItems: 'center',
      minWidth: 120,
      padding: 13,
    },
    filterButton: {
      minHeight: 'unset',
      borderRadius: 0,
      padding: 13,
      height: 44,
      flex: 1,
    },
    itemsContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      justifyContent: 'flex-start',
      paddingTop: 90,
      zIndex: 10
    },
    closeIcon: {
      width: 24,
      height: 24,
    },
    container: {
      display: 'block'
    },
    listSubContainer: {
      flex: 1,
      padding: 0,
      marginBottom: 20
    },
    listTitle: {
      textTransform: 'capitalize',
      fontSize: 18,
      lineHeight: '21px',
      '@media (max-width: 767px)': {
        fontSize: 16,
        lineHeight: '19px',
      },
    },
    listText: {
      color: CommonTheme.textColour
    },
    loadingView: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    titleContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      gap: 10,
      flex: 1,
      flexDirection: 'column'
    },
    titleSubContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: 20,
    },
    emptyFacets: {
      display: 'flex',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 20
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/FilterDrawer.js